export const GEOLOCALIZADOS = 'GEOLOCALIZADOS';
export const VIRTUALIZADOS = 'VIRTUALIZADOS';